'use client';
var classes = {"root":"m-f8d312f2","symbolGroup":"m-61734bb7","starSymbol":"m-5662a89a","input":"m-211007ba","label":"m-21342ee4","symbolBody":"m-fae05d6a"};

export { classes as default };
//# sourceMappingURL=Rating.module.css.mjs.map
